<div class="product-created-modal-root">
  <div class="header">
    <h1>{{ labels.productCreated }}</h1>
  </div>
  <div class="body">
    <h2>
      {{ labels.added }}<strong>{{ data.name }}</strong
      >.
    </h2>
    <span>{{ labels.canEdit }}</span>
    <span
      ><strong>{{ labels.canReturn }}</strong></span
    >
  </div>
  <div class="footer">
    <button mat-stroked-button color="primary" (click)="goToAddRewards()">
      {{ labels.addReward }}
    </button>
    <button mat-flat-button color="primary" (click)="goToControlPanel()">
      {{ labels.returnToControl }}
    </button>
  </div>
</div>
